
import React from 'react';
import { Recipe, StructuredIngredient } from '@/types/recipe';
import { UnitSystem } from '@/utils/unitConversion/types';
import RecipeHeader from './RecipeHeader';
import RecipeMetadata from './RecipeMetadata';
import RecipeIngredientsList from './RecipeIngredientsList';
import RecipeInstructions from './RecipeInstructions';
import RecipeImage from './RecipeImage';

interface RecipeDetailProps {
  recipe: Recipe;
  structuredIngredients: StructuredIngredient[];
  instructions: string[];
  preferredUnits: UnitSystem;
  onUnitToggle: (value: UnitSystem) => void;
  isQuickRecipe: boolean;
  isComposition?: boolean;
  canEdit?: boolean;
  canDelete?: boolean;
  onEdit?: () => void;
  onDelete?: () => void;
}

const RecipeDetail: React.FC<RecipeDetailProps> = ({
  recipe,
  structuredIngredients,
  instructions,
  preferredUnits,
  onUnitToggle,
  isQuickRecipe,
  isComposition = false,
  canEdit = false,
  canDelete = false,
  onEdit,
  onDelete
}) => {
  return (
    <div>
      <RecipeHeader
        sourceUrl={recipe.source_url || undefined}
        preferredUnits={preferredUnits}
        onUnitToggle={onUnitToggle}
        tags={recipe.tags || []}
        isQuickRecipe={isQuickRecipe}
        isComposition={isComposition}
        servings={recipe.servings || undefined}
        canEdit={canEdit}
        canDelete={canDelete}
        onEdit={onEdit}
        onDelete={onDelete}
      />

      <div className="mb-6">
        <RecipeImage 
          recipe={recipe}
          size="lg"
          className="w-full"
        />
      </div>

      {!isQuickRecipe && (recipe.prepTime || recipe.cookTime) && (
        <RecipeMetadata
          prepTime={recipe.prepTime}
          cookTime={recipe.cookTime}
          servings={recipe.servings}
        />
      )}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
        <div className="md:col-span-1">
          <RecipeIngredientsList
            structuredIngredients={structuredIngredients}
          />
        </div>
        
        <div className="md:col-span-2">
          <RecipeInstructions
            instructions={instructions}
            isQuickRecipe={isQuickRecipe}
          />
        </div>
      </div>
    </div>
  );
};

export default RecipeDetail;
